import type { ReactNode } from 'react';

import BpkSwitch from '@skyscanner/backpack-web/bpk-component-switch';
import type { TextStyle } from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import BpkText from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './SwitchItem.module.scss';

const cls = cssModules(STYLES);

type Props = {
  onChange: Function;
  label: ReactNode;
  ariaLabel: string;
  disabled?: boolean;
  checked?: boolean;
  small?: boolean;
  textStyle?: TextStyle;
};

const SwitchItem = ({
  ariaLabel,
  checked,
  disabled = false,
  label,
  onChange,
  small = false,
  textStyle,
  ...rest
}: Props) => (
  <div className={cls('SwitchItem')}>
    <BpkText textStyle={textStyle}>{label}</BpkText>
    <BpkSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      ariaLabel={ariaLabel}
      small={small}
      {...rest}
    />
  </div>
);

export default SwitchItem;
